module.exports = __webpack_public_path__ + "img/figure-1.c3bbce68.png";